export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/fr.lyaml"));
vm(require("foundations-components/lang/fr.lyaml"));
vm(require("feature-monetization/lang/fr.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/fr.lyaml"));
vm(require("usage-based-billing-components-lib/lang/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/fr.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/fr.lyaml"));
at({ "fr": { "ui": { "UILoadingSpinner": { "busyText": "Chargement en cours", "completedText": "Charg\xE9" } }, "publicPricingPage": { "windowTitles": { "default": "Tarification | HubSpot" } } } });
};